import { IApiResponse, IPageMetaData, ISiteMetaData } from "../models/Interfaces";
import { BaseService } from "./BaseService";

export class MetaDataService extends BaseService {
  
  public getPageMetaData = async (pageid: number, strict: boolean = false) : Promise<Array<IPageMetaData>> => {
    if (this.siteKey && pageid) {
      const url: string = `/SiteAdmin/GetMetaData/${this.siteKey}/${pageid}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve page meta data");
          if (strict) throw new Error("Unable to load page meta tags");
        }
      }
    }
    return [];
  }

  public savePageMetaData = async (meta: IPageMetaData) : Promise<IPageMetaData | null> => {
    if (this.siteKey && meta) {
      const url: string = `/SiteAdmin/AddUpdateMetaData`;
      const res = await this._ajaxService.Post<IApiResponse>(url, meta, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        this.EmitDataError(res, "Failed to save page meta data");
      }
    }
    return null;
  }

  public deletePageMetaData = async (metaid: number, pageid: number) : Promise<boolean> => {
    if (this.siteKey && metaid && pageid) {
      const url: string = `/SiteAdmin/DeleteMetaData/${this.siteKey}/${metaid}/${pageid}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200) {
        return true;
      }
    }
    return false;
  }

  public getSiteMetaData = async (lang: string) : Promise<Array<ISiteMetaData> | null> => {
    if (this.siteKey && lang) {
      const url: string = `/SiteAdmin/GetSiteMetaData/${this.siteKey}/${lang}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve site meta data");
        }
      }
    }
    return null;
  }

  public saveSiteMetaData = async (meta: ISiteMetaData) : Promise<ISiteMetaData | null> => {
    if (this.siteKey && meta) {
      const url: string = `/SiteAdmin/AddUpdateSiteMetaData`;
      const res = await this._ajaxService.Post<IApiResponse>(url, meta, true);

      if (res?.StatusCode && res.ReturnData) {
        return res.ReturnData;
      } else {
        this.EmitDataError(res, "Failed to save site meta data");
      }
    }
    return null;
  }

  public deleteSiteMetaData = async (metaid: number) : Promise<boolean> => {
    if (this.siteKey && metaid) {
      const url: string = `/SiteAdmin/DeleteSiteMetaData/${this.siteKey}/${metaid}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200) {
        return true;
      }
    }
    return false;
  }

  public newPageMetaData = (pageid: number) : IPageMetaData | null => {
    if (this.siteKey && pageid) {
      return {
        Id: 0,
        PageId: pageid,
        SiteId: this.siteKey,
        Key: "",
        Value: ""
      };
    }
    return null;
  }

  public newSiteMetadata = (language: string) : ISiteMetaData | null => {
    if (this.siteKey && language) {
      return {
        Id: 0,
        SiteId: this.siteKey,
        Language: language,
        MetaKey: "",
        MetaValue: ""
      };
    }
    return null;
  }
}